import React, { Component } from 'react'
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer
} from '@material-ui/core'
// import uuid from 'uuid/v4'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import { connect } from 'react-redux'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import * as actions from '../../../../../store/actions'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

class GradeTable extends Component {
  state = {
    gradeData: [],
    data: [],
    adjustData: []
  }

  sumBudget = () => {
    let sum = 0
    this.props.gradeData.map(item => {
      sum = +sum + +item.budget
      return item
    })
    return `${sum} (${this.props.total_budget}%)`
  }

  sumAmount = () => {
    let sum = 0
    this.props.gradeData.map(item => {
      sum = +sum + +item.amount
      return item
    })

    return `${sum} (${this.props.total_amount ? this.props.total_amount : 0})`
  }

  render () {
    return (
      <Aux>
        <Paper>
          {this.props.gradeData.length > 0 ? (
            <TableContainer>
              <Table stickyHeader size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell align='center'>{this.props.translate('grade')}</TableCell>
                    <TableCell align='center'>{this.props.translate('budget')} (%)</TableCell>
                    <TableCell align='center'>{this.props.translate('amount')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.props.gradeData.map(row => (
                    <TableRow key={row.value_list_id}>
                      <TableCell align='center'>{row.value_list_name}</TableCell>
                      <TableCell align='center'>
                        <InputGroup
                          rows
                          inputType={'input'}
                          // configs={formWithOptions.elementConfig}
                          // changed={e => this.inputChanged('budget', row.id, e)}
                          inputValue={row.budget || 0}
                          configs={{ endAdornment: '%' }}
                        />
                      </TableCell>
                      <TableCell align='center'>
                        <InputGroup
                          inputType={'input'}
                          configs={{ type: 'number' }}
                          validations
                          invalid={
                            this.props.isBoard
                              ? false
                              : row.amount > +row.checkAmount + 1 ||
                                row.amount < +row.checkAmount - 1
                          }
                          touched
                          validationError={
                            row.amount > +row.checkAmount + 1 || row.amount < +row.checkAmount - 1
                              ? '+/- ไม่เกิน 1'
                              : ''
                          }
                          changed={e => this.props.inputChanged('amount', row.value_list_id, e)}
                          inputValue={row.amount}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell align='center'>Total</TableCell>
                    <TableCell align='center'>{this.sumBudget()}</TableCell>
                    <TableCell align='center'>{this.sumAmount()}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : null}
        </Paper>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.horizontalForceRank.pagination,
    total: state.horizontalForceRank.total,
    filters: state.horizontalForceRank.filter,
    filtered: state.horizontalForceRank.filtered,
    filterLoadingQueue: state.horizontalForceRank.filterLoadingQueue,
    filterData: state.horizontalForceRank.filterData,
    filterLoading: state.horizontalForceRank.filterLoading,
    // gradeData: state.horizontalForceRank.gradeData,
    pageLoading:
      state.horizontalForceRank.filterLoading ||
      state.horizontalForceRank.appraisalTypes.length === 0,
    filterOptions: {
      companyFilterOptions: state.horizontalForceRank.filterCompanies,
      formFilterOptions: state.horizontalForceRank.filterForms,
      levelFilterOptions: state.horizontalForceRank.filterLevelGroups
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchForceRankList: param => dispatch(actions.fetchReStoreHorizontalForceRankList(param))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(GradeTable))
